import styled from 'styled-components';

type WrapperProps = {
  mr?: string;
};

const Wrapper = styled.label<WrapperProps>`
  display: block;
  position: relative;
  padding-left: 28px;
  margin-right: ${(props: WrapperProps) => props.mr};
  cursor: pointer;
  font-size: 16px;
  user-select: none;
  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }
  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 20px;
    width: 20px;
    background-color: white !important;
    border: 1px solid #ccd4d6;
    border-radius: 3px;
  }
  &:hover input ~ .checkmark {
    background-color: #ccc !important;
  }
  input:checked ~ .checkmark {
    background-color: var(--app-color-dark) !important;
  }
  .checkmark:after {
    content: '';
    position: absolute;
    display: none;
  }
  input:checked ~ .checkmark:after {
    display: block;
  }
  .checkmark:after {
    left: 7px;
    top: 4px;
    width: 3px;
    height: 7px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }
  .tf-right {
    right: 0 !important;
    left: auto !important;
  }
`;

export default Wrapper;
